import { connect } from 'react-redux'
import { resumeNewsTicker } from 'redux/actions'
import NewsTicker from 'pages/dashboard/NewsTicker'

const mapStateToProps = (state, ownProps) => ({
  aol: ownProps.aol
})

const mapDispatchToProps = dispatch => ({
  resumeNewsTicker: () => dispatch(resumeNewsTicker())
})

export default connect(mapStateToProps, mapDispatchToProps)(NewsTicker)
